var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranchlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 69,
    viewBox: "0 0 137 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3935_167875)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.33 0H85.67L47.34 38.33H12.58C12.1 35.31 9.49 33 6.33 33C2.83 33 0 35.84 0 39.33C0 42.82 2.84 45.66 6.33 45.66C9.49 45.66 12.1 43.35 12.58 40.33H32.59L61.09 68.83H100.5C101.05 68.83 101.5 68.38 101.5 67.83C101.5 67.28 101.05 66.83 100.5 66.83H61.91L35.41 40.33H120.83C121.38 40.33 121.83 39.88 121.83 39.33C121.83 38.78 121.38 38.33 120.83 38.33H50.17L86.5 2H135.34C135.89 2 136.34 1.55 136.34 1C136.34 0.45 135.89 0 135.34 0H135.33Z",
    fill: "#C6CECE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.33C0 35.84 2.83 33 6.33 33C9.83 33 12.66 35.83 12.66 39.33C12.66 42.83 9.83 45.66 6.33 45.66C2.83 45.66 0 42.82 0 39.33Z",
    fill: "#F4F4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3935_167875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136.33,
    height: 68.83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchlogo);
export default __webpack_public_path__ + "static/media/branchlogo.5265a6946249750e0aece70d1b8d0f54.svg";
export { ForwardRef as ReactComponent };